<template>
  <div class="empty-state"
  >
    <div>
      <img
        src="/images/icons/mytrip.svg"
        alt="My Trips"
      />
      <h2 class="title">
        Oops, it seems we've hit a snag in your exploration journey!
      </h2>
      <p class="content">
        Oh no! It seems like your adventure-seeking compass has led you to
        uncharted territory. Don't worry; we're here to help you find your ideal
        destination.
      </p>
      <h3 class="subtitle">Adjust Your Filter Options</h3>
      <p class="subcontent">
        It's possible that your current filter settings are a bit too specific.
        Consider broadening your filter options or expanding your search area to
        unlock a world of possibilities. Try different combinations of filters
        to tailor your search to your heart's desire.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    Attractions: {
      type: [Array],
    },
  },
};
</script>

<style
  lang="scss"
  scoped
>
  .empty-state {
    display: flex;
    width: auto;
    height: 490px;
    background-color: #f0f7f7;
    margin: 75px auto 0;
    justify-content: center;
    align-items: center;

    div {
      width: 435px;
      height: auto;
      margin: 15px;
    }

    img {
      width: 74px;
      height: 74px;
    }

    h2.title {
      font-family: 'klinicslabbold';
      font-weight: 400;
      font-size: 32px;
      line-height: 38.4px;
      color: #1a3138;
      margin-top: 0;
    }

    h3.subtitle {
      font-family: 'klinicslabbold';
      font-size: 24px;
      font-weight: 400;
      line-height: 26px;
      letter-spacing: 0px;
      text-align: center;
      color: #000000;
    }

    p.content {
      font-family: 'IdealSans-Book';
      font-weight: 325;
      font-size: 15px;
      line-height: 27px;
      color: #000000;
    }
    div > p.subcontent {
      font-family: 'IdealSans-Book';
      font-size: 13.75px;
      font-weight: 325;
      line-height: 19px;
      letter-spacing: 0px;
      text-align: center;
      color: #000000;
    }

    @media screen and (min-width: 565px) {
      width: 563px;
      height: 490px;
      margin: 75px auto 0;

      div {
        width: 435px;
        height: 362px;
        margin: 65px auto;
      }
    }
  }
</style>
